//format
import { Layout, Row, Col } from 'antd';

const { Header, Content, Footer } = Layout;

export default function ContentFormatXZ (props) {

  return (
    <>
      {/* header */}
      <Header className='d-none'></Header>
      
      {/* content */}
      <Layout>
        <Content style={{ minHeight:'100vh' }}>
          <div className={props.form ==='full' ? '' : 'd-none'}>
            <Row>
              <Col xs={0} md={0} lg={0}></Col>
              <Col xs={24} md={24} lg={24}>{props.data}</Col>
              <Col xs={0} md={0} lg={0}></Col>
            </Row>
          </div>

          <div className={props.form ==='wide' ? 'mx-3' : 'd-none'}>
            <Row>
              <Col xs={0} md={0} lg={0}></Col>
              <Col xs={24} md={24} lg={24}>{props.data}</Col>
              <Col xs={0} md={0} lg={0}></Col>
            </Row>
          </div>

          <div className={props.form ==='medium' ? 'mx-3' : 'd-none'}>
            <Row>
              <Col xs={0} md={6} lg={4}></Col>
              <Col xs={24} md={12} lg={16}>{props.data}</Col>
              <Col xs={0} md={6} lg={4}></Col>
            </Row>
          </div>

          <div className={props.form ==='small' ? 'mx-3' : 'd-none'}>
            <Row>
              <Col xs={0} md={6} lg={7}></Col>
              <Col xs={24} md={9} lg={10}>{props.data}</Col>
              <Col xs={0} md={6} lg={7}></Col>
            </Row>
          </div>

          <div className={props.form ==='mini' ? 'mx-3' : 'd-none'}>
            <Row>
              <Col xs={0} md={6} lg={9}></Col>
              <Col xs={24} md={12} lg={6}>{props.data}</Col>
              <Col xs={0} md={6} lg={9}></Col>
            </Row>
          </div>


        </Content>
      </Layout>

      {/* footer */}
      <Footer style={{ textAlign: 'center' }}>{}</Footer>
    </>
    )
  }